import { LinkItem } from '@occc-app/design-system';
import { routeCreator } from '@occc-app/routes/ProductGroup/utils';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: programManagementRouteCreator.base(), label: 'Program Management' },
  { to: routeCreator.list(), label: 'Product Groups' },
  {
    key: routeCreator.update(':id'),
    label: 'Update Product Group',
  },
];
